import {getLogo} from "@/helpers/logo";

export default {
    chart: {
        spacing: [15, 50, 50, 50],
        height: 600,
        type: 'networkgraph',
        backgroundColor: '#fff',
        marginTop: 50
    },
    title: {
        text: '',
    },
    tooltip: {
        useHTML: true,
        className: "popover-custom",
        stickOnContact: true,
        style: {
            pointerEvents: 'auto',
        },
        formatter: function () {
            if ('node_name' in this.point) {
                return `
<a onclick="showPartnerships({id: ${this.point.company_id}, name: '${this.point.node_name}'})">
    <div style="display: flex; padding: 5px; align-items: center; gap: 10px; white-space: no-wrap;">
        <div style="width: 50px; overflow: hidden;">
            <img src="${getLogo(this.point.logo)}" style="margin: 0; width: 100%; object-fit: contain;border-radius: 8px;" alt="${this.point.node_name}">
        </div>
        <div>
            <strong style="display: block;">${this.point.node_name}</strong>
        </div>
    </div>
</a>`;
            } else {
                return `
<div style="display: flex; padding: 5px; align-items: center; gap: 20px;">
    <div style="position: relative">
        <img src="${getLogo(this.point.enterprise_logo)}" style="width: 50px;border-radius: 8px;box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25);background-color: #fff;" alt="${this.point.enterprise_name}">
        <img src="${getLogo(this.point.startup_logo)}" style="width: 30px; height: 30px; object-fit: cover; position: absolute; top: 30px; left: 30px;border-radius: 4.5px;box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25);" alt="${this.point.startup_name}">
    </div>

    <div style="width: 100%;">
        <strong>${this.point.name}</strong>
        <div style="font-size: 12px; margin-top: 10px">${this.point.summary ?? ''}</div>
    </div>
</div>` + (this.point.show_footer ? `
<div class="PG-footer" style="display: flex; padding: 8px 15px; align-items: center; gap: 20px; background-color: #f2f2f2; margin: 20px -8px -8px -8px; border-radius: 0 0 4px 4px;">
    <a onclick="showSimilar(${this.point.startup_id})" style="display: flex; flex: 0 0 50%; font-size: 14px;color: #3b3b3b;">
        <img src="/icon-similar-light-blue.svg" style="display: block; margin-right: 7px; width: 16px; height: 16px;" width="16" alt=""/>
        Similar Startups
    </a>

    <a onclick="addToTracker(${this.point.startup_id})" style="display: flex; flex: 0 0 50%; font-size: 14px;color: #3b3b3b;">
        <img src="/icon-track-light.svg" style="display: block; margin-right: 7px; width: 16px; height: 16px;" width="16" alt=""/>
        Add to tracker
    </a>
</div>` : '');
            }
        }
    },
    plotOptions: {
        networkgraph: {
            layoutAlgorithm: {
                enableSimulation: false,
                integration: 'verlet',
                linkLength: 50,
                repulsion: 2, // default is 1, try increasing to 2, 3, or higher
            }
        }
    },
    series: [],
}
